import { HttpClient } from '../interceptor';

export class OrderManagementApi{
    // 获取订单列表
    static getOrderList = (param) => {
        return new Promise(resolve => {
            HttpClient.post('/api/orderClassController/queryClassroomOrderListToB', param).then(res => {
                if(res.data.status === 200){
                    resolve(res.data.content);
                }
            }).catch(err => console.log(err));
        })
    }
    // 退单
    static rejectOrder = (param) => {
        return new Promise(resolve => {
            HttpClient.post('/api/orderClassController/chargeClassroomBack', param).then(res => {
                resolve(res);
            }).catch(err => console.log(err));
        })
    }

    // 导出订单
    static exportOrder = (param) => {
        return new Promise(resolve => {
            HttpClient.post('/api/orderClassController/export', param, {
                responseType: "blob"
            }).then(res => {
                resolve(res.data);
            }).catch(err => console.log(err));
        })
    }

    // 获取课程订单列表
    static getCourseOrderList = (param) => {
        return new Promise(resolve => {
            HttpClient.post('/api/orderCourseController/getCourseOrderListToB', param).then(res => {
                if(res.data.status === 200){
                    resolve(res.data.content);
                }
            }).catch(err => console.log(err));
        })
    }

    static exportCourseOrder = (param) => {
        return new Promise(resolve => {
            HttpClient.post('/api/courseController/exportCourseOrderSign', param, {
                responseType: "blob"
            }).then(res => {
                resolve(res.data);
            }).catch(err => console.log(err));
        })
    }
    // static exportCourseOrder = (param) => {
    //     return new Promise(resolve => {
    //         HttpClient.post('/api/courseController/exportCourseSign', param, {
    //             responseType: "blob"
    //         }).then(res => {
    //             resolve(res.data);
    //         }).catch(err => console.log(err));
    //     })
    // }
}